/*
* @Author: LiuMouLiang
* @Date:   2024-01-24
* 兼容老API
import { process_result } from '@/api/util';
*/
import {
    _noValue,
    _for,
    getObjVal,
    awaitTo,
    typeOf,
    promiseAllSettled as _promiseAllSettled,
} from 'tools';
import { IS_MOCK } from '_libs/host';
import defaultURL from '_libs/APIURL'

export const api_mock = IS_MOCK ? '' : 'api/';

export const promiseAllSettled = async function(requestList){
    const resList = await _promiseAllSettled(requestList);
    let resObj = {};
    _for(resList, (res, i) => {
        const id = res.id || i;
        resObj[id] = res
    });
    return resObj;
};

/**
 * 处理响应结果，提取关键信息并返回结构化数据
 * @param {Object} res - 原始响应对象
 * @returns {Object} 包含data, resCode, info, code的对象
 */
export const process_result = function(res){
    // 尝试从不同路径获取响应码和信息
    const resCode = getObjVal(res, 'data.resCode') || getObjVal(res, 'resCode');
    const info = getObjVal(res, 'data.info') || getObjVal(res, 'info');
    const code = getObjVal(res, 'data.code') || getObjVal(res, 'code');
    // 尝试获取数据，处理数据可能不存在或在不同路径的情况
    let data = getObjVal(res, 'data.data');
    if(_noValue(data)){
        data = getObjVal(res, 'data');
    };
    return {
        data,
        resCode,
        info,
        code,
    }
}

/**
 * 处理成功响应的结果，并根据结果状态执行resolve或reject
 * @param {Object} res - 原始响应对象
 * @param {Function} resolve - 成功时的回调函数
 * @param {Function} reject - 失败时的回调函数
 */
export const process_result_success = function(res, resolve, reject){
    // 使用process_result处理响应对象
    const { data, resCode, code, info } = process_result(res);
    const dataT = typeOf(data);
    // 根据响应码判断是成功还是失败
    if(resCode === '000001' || code === 200) {
        resolve(_noValue(data) ? info || '操作成功' : data);
    }else if(!resCode && !code && typeOf(res,'array')){ //直接返回数组，没有code
        resolve(res);
    }else{
        // 接口的错误信息获取不规范，只能做兼容处理
        let errInfo = ''; //错误信息
        if(typeOf(info, 'string')){
            errInfo = info;
        }
        if(['array','object'].includes(dataT)){
            data.errInfo = errInfo;
            reject(data);
        }else {
            // 优先获取data中的错误信息，如果没有再尝试获取info
            if(dataT === 'string'){
                errInfo = data;
            };
            res.errInfo = errInfo || '';
            reject(res);
        };
    }
};

/**
 * 将指定函数处理过程包装成一个Promise
 * @param {Function} promiseFn - 返回Promise的函数
 * @returns {Promise} 包装后的Promise对象
 */
export const process_promise = function(promiseFn, successFn){
    return new Promise((resolve, reject) => {
        // 执行promiseFn，并处理成功或失败的情况
        return promiseFn.then((res) => {
            successFn && successFn(res, 1);
            return process_result_success(res, resolve, reject)
        }).catch((err) => {
            const errT = typeOf(err);
            if(errT === 'object'){
                successFn && successFn(err, 2);
                return process_result_success(err, resolve, reject);
            }else if(errT === 'error'){
                //依照以前人封装的逻辑，遇到接口异常就提示错误并返回错误信息
                //现改为异常后默认返回错误信息但有noErrMsg时不返回，保证就算接口失败也不影响页面
                const noErrMsg = getObjVal(err, 'config.noErrMsg') || false;
                reject({
                    isError: true, //是否是接口错误
                    errInfo: noErrMsg ? '' : err.message,
                    err,
                });
            }else {
                reject(err);
            };
        });
    });
};

/**
 * 等待所有Promise完成
 * @param {Array} list - Promise数组
 * @returns {Promise} 所有Promise结果的数组
const [err, [inImportantData, basicBusinessInfoData]] = await promise_all([]);
 */
export const promise_all = function(list){
    return awaitTo(Promise.all(list));
};

/**
 * 根据键获取URL，优先使用APIURL中的配置，其次是defaultURL，最后是键本身
 * @param {string} key - URL配置的键
 * @returns {string} 对应键的URL
 */
export const getUrl_APIURL = function(key){
    const url = defaultURL[key] || key;
    return url;
};

//asycn等待时间
export const asyncWait = function(time = 500){
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, time);
    });
};



// WEBPACK FOOTER //
// ./src/api/util.js